"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var style_1 = require("./style");
var Table = function (_a) {
    var antdTableProps = _a.antdTableProps;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (react_1.default.createElement(style_1.TableContainer, null,
        react_1.default.createElement(antd_1.Table, __assign({ size: "small" }, antdTableProps))));
};
exports.default = Table;
